import { render, staticRenderFns } from "./FloatBtnGroup.vue?vue&type=template&id=474613d1&scoped=true"
import script from "./FloatBtnGroup.vue?vue&type=script&lang=js"
export * from "./FloatBtnGroup.vue?vue&type=script&lang=js"
import style0 from "./FloatBtnGroup.vue?vue&type=style&index=0&id=474613d1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "474613d1",
  null
  
)

export default component.exports